import React from 'react';
// Analytics
import { usePageTracking } from '../../hooks/useAnalytics';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  homePageAdditionalMeta,
  homePageStructuredData,
} from '../../utils/data/MetaData';
// Images
import CatLogoSvg from '../../assets/images/logos/cat-app-main-logo-svg.svg';
// Components
import { HelmetItem } from '../../components/utils/HelmetItem';
import SponsorMiniBanner from '../../components/sponsor/SponsorMiniBanner';
import SideTextComponent from '../../components/general/SideTextComponent';
import FiveStarComponent from '../../components/general/FiveStarComponent';
import TextLogoSection from '../../components/general/TextLogoSection';
import DownloadIconSection from '../../components/general/DownloadIconSection';

const HomePage = React.memo(() => {
  usePageTracking();

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Home'
        desc={`${CompanyName} - Your ultimate destination for cute cat videos, fun games, and exclusive feline content.`}
        keywords='cat videos, cute cats, cat games, feline fun, cat content'
        additionalMeta={homePageAdditionalMeta}
        structuredData={homePageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen w-full h-full'>
        <header className='grid w-full h-full min-h-screen lg:max-h-screen lg:overflow-hidden bg-colour2 px-1 py-1'>
          <div className='bg-colour3 rounded-2xl px-6 py-6'>
            <section className='relative grid h-full w-full items-center justify-center bg-colour1 rounded-2xl shadow-cardShadow'>
              <SideTextComponent />

              <SponsorMiniBanner />

              <FiveStarComponent />

              <DownloadIconSection />

              <TextLogoSection />

              <article className='-mt-10'>
                <figure className='flex justify-center'>
                  <img
                    src={CatLogoSvg}
                    alt='Cat app logo'
                    className='min-w-44 max-w-44 lg:min-w-96 lg:max-w-96 w-fit h-auto'
                  />
                </figure>
                <section className='text-center'>
                  <h1 className='text-3xl font-atop text-colour3 text__stroke'>
                    Available to Download Soon!
                  </h1>
                </section>
              </article>
            </section>
          </div>
        </header>
      </div>
    </>
  );
});

export default HomePage;
